// John Eldhose 20190522
import React, { Component } from 'react';
import  { Link } from 'react-router-dom';
import { Button, Checkbox, CircularProgress, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { ChevronLeft, Send } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import countries from './countries';
import { isAuthenticated } from '../../Api/isAuthenticated';
import { getProfile } from '../../Api/getProfile';
import { getAddress } from '../../Api/getAddress';
import { getCache } from '../../Api/getCache';
import { updateCache } from '../../Api/updateCache';

class ProfileAddress extends Component {

  state = {
    isAuth: 0,
    profile: {},
    addresses: [],
    address: {ADDRESSID: '', ADDRESS1: '', CITY: '', STATE: '', POSTALCODE: '', COUNTRY: ''},
    ADDRESSID: '',
    sameasshipto: true,
    baddress: {ADDRESSID: '', ADDRESS1: '', CITY: '', STATE: '', POSTALCODE: '', COUNTRY: ''},
    phone: '',
    loaded: 0
  }
  componentWillMount() {
    isAuthenticated()
      .then((auth) => {
        if(auth.status === 'true') {
          this.setState({
            isAuth: auth.auth, loaded: (this.state.loaded + 1)
          });
          if(auth.auth > 4)
            getAddress()
              .then((add) => {
                if(add['status'] === 'true') {
                  var sS = {addresses: add['data'], loaded: (this.state.loaded + 1)};
                  if(
                    typeof(this.props.DefaultFirst) !== 'undefined' &&
                    this.props.DefaultFirst === true &&
                    typeof(add['data'][0].ADDRESSID) !== 'undefined'
                  ) {
                    sS.ADDRESSID = add['data'][0].ADDRESSID;
                    sS.address = add['data'][0];
                  }
                  this.setState(sS);
                }
              })
              .catch((error) => { console.log(error); })
          else
            getCache('address')
              .then((cache) => {
                if(cache['status'] === 'true') {
                  const address = this.state.address;
                  const keys = Object.keys(address);
                  for(var i = 0; i < keys.length; i++)
                    if(typeof cache.data[keys[i]] !== 'undefined')
                      address[keys[i]] = cache.data[keys[i]];
                  this.setState({
                    address: address,
                    baddress: JSON.parse(JSON.stringify(address)),
                    loaded: (this.state.loaded + 1)
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              })
        }
      })
      .catch(() => {
        this.setState({loaded: true});
      })
    getProfile()
      .then((prof) => {
        if(prof['status'] === 'true')
          this.setState({ profile: prof.data, loaded: (this.state.loaded + 1)});
      })
      .catch((err) => {
        console.log(err);
      })
  }
  handleChangeAddress = (e) => {
    for(var i = 0; i < this.state.addresses.length; i++)
      if(e.target.value === this.state.addresses[i].ADDRESSID) {
        if(this.state.sameasshipto)
          this.setState({
            ADDRESSID: e.target.value, address: this.state.addresses[i], baddress: JSON.parse(JSON.stringify(this.state.addresses[i]))
          });
        else
          this.setState({
            ADDRESSID: e.target.value, address: this.state.addresses[i]
          });
        break;
      }

  }
  updtAddr = (key, val) => {
    var address = this.state.address;
    address[key] = val;
    if(this.state.sameasshipto)
      this.setState({ address: address, baddress: JSON.parse(JSON.stringify(address)) });
    else
      this.setState({ address: address });
  }
  handleChangesameasshipto = (e) => {
    this.setState({
      sameasshipto: e.target.checked,
      baddress: JSON.parse(JSON.stringify(this.state.address))
    })
  }
  updtBAddr = (key, val) => {
    var address = this.state.baddress;
    address[key] = val;
    this.setState({ baddress: address });
  }
  canContinue = () => {
    var i, can = (this.state.loaded > 2);
    if(can) {
      const profile = ['CompanyDescription', 'FirstName', 'LastName', 'email'];
      for(i = 0; i < profile.length; i++)
        if(this.state.profile[profile[i]] === '') {
          can = false;
          break;
        }
    }
    const address = ['ADDRESS1', 'CITY', 'STATE', 'POSTALCODE', 'COUNTRY'];
    if(can) {
      for(i = 0; i < address.length; i++)
        if(this.state.address[address[i]] === '') {
          can = false;
          break;
        }
    }
    if(!this.noBillTo() && can) {
      for(i = 0; i < address.length; i++)
        if(this.state.baddress[address[i]] === '') {
          can = false;
          break;
        }
    }
    if(!this.noBillTo() && this.state.phone === '')
      can = false;
    return can;
  }
  handleContinue = () => {
    if(this.state.isAuth < 5) {
      updateCache('address', this.state.address)
        .then((status) => { })
        .catch((err) => { console.log(err); })
    }
    const address = this.state.baddress;
    address.PHONE = this.state.phone;
    this.props.Continue(this.state.profile, this.state.address, address);
  }
  noBillTo = () => {
    return (
      typeof this.props.NoBillTo === 'boolean' && this.props.NoBillTo === true
    );
  }
  getName = () => {
    return (
      <Grid container>

      </Grid>
    );
  }
  getBillTo = () => {
    return (
      <div>
        <Typography
          variant='title'
          style={{ paddingTop: '20px' }}
        >
          <FormattedMessage
            id='Bill to Address'
            defaultMessage='Bill to Address'
          />
        </Typography>
        <Typography variant='subheading' style={{ textAlign: 'left' }}>
          <FormattedMessage
            id='Same as Ship to Address'
            defaultMessage='Same as Ship to Address'
          />
          <Checkbox
            color='primary'
            checked={this.state.sameasshipto}
            onChange={this.handleChangesameasshipto}
          />
        </Typography>
        <TextField
          fullWidth
          label={
            <FormattedMessage id='Address' defaultMessage='Address' />
          }
          name='Address'
          value={this.state.baddress.ADDRESS1}
          onChange={(e) => this.updtBAddr('ADDRESS1', e.target.value)}
          disabled={this.state.sameasshipto}
        />
        <TextField
          fullWidth
          label={<FormattedMessage id='City' defaultMessage='City' />}
          name='City'
          value={this.state.baddress.CITY}
          onChange={(e) => this.updtBAddr('CITY', e.target.value)}
          disabled={this.state.sameasshipto}
        />
        <Grid container>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <TextField
              fullWidth
              label={
                <FormattedMessage id='State' defaultMessage='State' />
              }
              name='State'
              value={this.state.baddress.STATE}
              onChange={(e) => this.updtBAddr('STATE', e.target.value)}
              disabled={this.state.sameasshipto}
            />
          </Grid>
          <Grid item xs={false} sm={false} md={1} lg={1} xl={1} />
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <TextField
              fullWidth
              label={<FormattedMessage id='Zip' defaultMessage='Zip' />}
              name='Zip'
              value={this.state.baddress.POSTALCODE}
              onChange={
                (e) => this.updtBAddr('POSTALCODE', e.target.value)
              }
              disabled={this.state.sameasshipto}
            />
          </Grid>
        </Grid>
        <TextField
          fullWidth
          select
          label={
            <FormattedMessage id='Country' defaultMessage='Country' />
          }
          value={this.state.baddress.COUNTRY}
          onChange={(e) => this.updtBAddr('COUNTRY', e.target.value)}
          disabled={this.state.sameasshipto}
        >
          {countries.map((country) => {
            return (
              <MenuItem key={country} value={country}>
                {country}
              </MenuItem>
            );
          })}
        </TextField>
        <Typography
          variant='title'
          style={{ paddingTop: '20px' }}
        >
          <FormattedMessage
            id='Bill to Phone'
            defaultMessage='Bill to Phone'
          />
        </Typography>
        <TextField
          fullWidth
          label={
            <FormattedMessage
              id='Phone Number'
              defaultMessage='Phone Number'
            />
          }
          value={this.state.phone}
          onChange={(e) => this.setState({ phone: e.target.value })}
        />
      </div>
    );
  }

  render() {
    if(this.state.loaded < 3)
      return <CircularProgress />;
    else
      return (
        <div>
          <Typography variant='display1'>
            <center>
              <font color='#385687'>
                <FormattedMessage
                  id='Confirm User Information'
                  defaultMessage='Confirm User Information'
                />
              </font>
            </center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage
                        id='Company Name'
                        defaultMessage='Company Name'
                      />
                    }
                    value={this.state.profile.CompanyDescription}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage
                        id='First Name'
                        defaultMessage='First Name'
                      />
                    }
                    value={this.state.profile.FirstName}
                    disabled
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} lg={1} xl={1} />
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage
                        id='Last Name'
                        defaultMessage='Last Name'
                      />
                    }
                    value={this.state.profile.LastName}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage
                        id='Email Address'
                        defaultMessage='Email Address'
                      />
                    }
                    value={this.state.profile.email}
                    disabled
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} lg={1} xl={1} />
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage
                        id='Work Phone'
                        defaultMessage='Work Phone'
                      />
                    }
                    value={this.state.profile.phone}
                    disabled
                  />
                </Grid>
              </Grid>
              <Typography variant='caption' style={{ textAlign:'right' }}>
                <Link to='/profile'>
                  <FormattedMessage
                    id='Update Profile'
                    defaultMessage='Update Profile'
                  />
                </Link>
              </Typography>
              <p /><p />
              <Typography variant='title'>
                <FormattedMessage
                  id='Address'
                  defaultMessage='Address'
                />
              </Typography>
              {(this.state.isAuth > 4) ? (
                <div>
                  <TextField
                    fullWidth
                    select
                    label={
                      <FormattedMessage
                        id='Select an address from the list'
                        defaultMessage='Select an address from the list'
                      />
                    }
                    value={this.state.ADDRESSID}
                    onChange={this.handleChangeAddress}
                  >
                    {this.state.addresses.map((add) => (
                      <MenuItem key={add.ADDRESSID} value={add.ADDRESSID}>
                        {add.ADDRESS1}, {add.CITY}, {add.STATE}, {add.POSTALCODE}, {add.COUNTRY}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Typography variant='caption' style={{ textAlign:'right' }}>
                    <Link to='/accountdetailsteam'>
                      <FormattedMessage
                        id='Update Address'
                        defaultMessage='Update Address'
                      />
                    </Link>
                  </Typography>
                </div>) : (<br />)
              }
              <TextField
                fullWidth
                label={
                  <FormattedMessage id='Address' defaultMessage='Address' />
                }
                name='Address'
                value={this.state.address.ADDRESS1}
                onChange={(e) => this.updtAddr('ADDRESS1', e.target.value)}
                disabled={this.state.isAuth > 4}
              />
              <TextField
                fullWidth
                label={<FormattedMessage id='City' defaultMessage='City' />}
                name='City'
                value={this.state.address.CITY}
                onChange={(e) => this.updtAddr('CITY', e.target.value)}
                disabled={this.state.isAuth > 4}
              />
              <Grid container>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <TextField
                    fullWidth
                    label={
                      <FormattedMessage id='State' defaultMessage='State' />
                    }
                    name='State'
                    value={this.state.address.STATE}
                    onChange={(e) => this.updtAddr('STATE', e.target.value)}
                    disabled={this.state.isAuth > 4}
                  />
                </Grid>
                <Grid item xs={false} sm={false} md={1} lg={1} xl={1} />
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <TextField
                    fullWidth
                    label={<FormattedMessage id='Zip' defaultMessage='Zip' />}
                    name='Zip'
                    value={this.state.address.POSTALCODE}
                    onChange={
                      (e) => this.updtAddr('POSTALCODE', e.target.value)
                    }
                    disabled={this.state.isAuth > 4}
                  />
                </Grid>
              </Grid>
              <TextField
                fullWidth
                select
                label={
                  <FormattedMessage id='Country' defaultMessage='Country' />
                }
                value={this.state.address.COUNTRY}
                onChange={(e) => this.updtAddr('COUNTRY', e.target.value)}
                disabled={this.state.isAuth > 4}
              >
                {countries.map((country) => {
                  return (
                    <MenuItem key={country} value={country}>
                      {country}
                    </MenuItem>
                  );
                })}
              </TextField>
              {this.noBillTo() ? '' : this.getBillTo()}
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
          </Grid>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}
              style={{ textAlign: 'left'}}
            > {(
                typeof this.props.NoBackButton === 'boolean' && this.props.NoBackButton === true
              ) ? <div /> :
                <Button
                  color='secondary'
                  onClick={this.props.Back}
                >
                  <ChevronLeft />&nbsp;
                  <FormattedMessage id='Back' defaultMessage='Back' />
                </Button>
            }
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}
              style={{ textAlign: 'right'}}
            >
              <Button
                variant='raised'
                color='primary'
                onClick={this.handleContinue}
                disabled={!this.canContinue()}
              >
                <FormattedMessage id='Continue' defaultMessage='Continue' />
                &nbsp;<Send />
              </Button>
            </Grid>
          </Grid>
        </div>
      );
  }
}

export default ProfileAddress;



// WEBPACK FOOTER //
// ./src/components/lib/ProfileAddress.js